import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const PieChartShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435.8 435.7",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M209.9 217.8V0C92.8 4.3 0 100.6 0 217.8 0 338 97.8 435.7 218 435.7c117.5 0 213.6-93.5 217.8-209.9H217.9c-4.4 0-8-3.6-8-8z"
    })
  });
};

export { PieChartShape };
//# sourceMappingURL=PieChartShape.js.map
